import React from 'react';
import { noop } from 'lodash';
import { findDOMNode, render, unmountComponentAtNode } from 'react-dom';

class AskForEmailConsentClass {

  el = null;
  modalRef = null;
  resolvePromise = null;

  promise = new Promise((resolve) => { this.resolvePromise = resolve; });

  constructor(id, modalContents, passthroughProps) {
    if (document.getElementById(id)) {
      // eslint-disable-next-line no-console
      console.error(`Modal ${id} already displayed!`);
    }

    this.el = document.createElement('div');
    this.el.id = id;

    document.body.appendChild(this.el);

    render(
      <div className={'c-consent-modal-backdrop'}>
        <div className={'c-modal c-consent-modal xis-hidden c-notifications'} close={noop}>
          {modalContents({ close: this.close, ...passthroughProps })}
        </div>
      </div>,
      this.el
    );
  }

  close = value => () => {
    this.resolvePromise(value);
    this.unmount();
  };

  unmount = () => {
    unmountComponentAtNode(findDOMNode(this.el));
    document.body.removeChild(this.el);
  };

}

// eslint-disable-next-line arrow-body-style
const AskForEmailConsent = (id, child, passthroughProps) => {
  return new AskForEmailConsentClass(id, child, passthroughProps).promise;
};

export default AskForEmailConsent;



// WEBPACK FOOTER //
// ./src/app/reservation/components/AskForEmailConsentModal.jsx